import { Button } from "@kovernow/react-ui/components/button";
import { Eye, EyeOff } from "lucide-react";
import { useState, type ComponentProps } from "react";
import { useT } from "../core/use-t";
import { FormField } from "./FormField";

/** FormField with the "Show password" toggle (rules go in `hint`, shown up front). */
export function PasswordField(props: Omit<ComponentProps<typeof FormField>, "type" | "trailing">) {
  const t = useT();
  const [show, setShow] = useState(false);
  return (
    <FormField
      {...props}
      type={show ? "text" : "password"}
      trailing={
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className="size-11"
          aria-pressed={show}
          aria-label={t("auth.signIn.showPassword")}
          onClick={() => setShow((v) => !v)}
        >
          {show ? <EyeOff aria-hidden="true" /> : <Eye aria-hidden="true" />}
        </Button>
      }
    />
  );
}
